import * as style from './styles.css';
import { Accordion } from '@cian/ui-kit';
import { IAnswersOnQuestions } from 'shared/types/answersOnQuestions';

interface IAnswersOnQuestionsItemProps extends IAnswersOnQuestions {
  onItemClick: (question: string, isOpen: boolean) => void;
}

export const AnswersOnQuestionsItem: React.FC<IAnswersOnQuestionsItemProps> = ({ answers, title, onItemClick }) => {
  const convertToContent = (answers: string[], answerType?: string) => {
    if (answerType === 'list') {
      return (
        <ul>
          {answers.map((answer, index) => (
            <li className={style['answer']} key={index}>
              {answer}
            </li>
          ))}
        </ul>
      );
    }

    return (
      <>
        {answers.map((answer, index) => (
          <div className={style['answer']} key={index}>
            {answer}
          </div>
        ))}
      </>
    );
  };

  const items = answers.map(item => ({ title: item.title, content: convertToContent(item.answer, item.answerType) }));

  return (
    <div className={style['container']}>
      <div className={style['title']}>{title}</div>
      <Accordion onItemClick={e => onItemClick(e.target.title, e.open)} items={items} />
    </div>
  );
};
